import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type BannerId = string

interface BannerState {
  banners: Record<BannerId, boolean>
  dismissBanner: (id: BannerId) => void
}

export const useBannerStore = create<BannerState>()(
  immer((set) => ({
    banners: {},

    dismissBanner: (id) =>
      set((state) => {
        state.banners[id] = true
      }),
  })),
)
